export default __webpack_public_path__ + "50a09df32084844f27072ac3bb6b6142.jpg";